import { render, staticRenderFns } from "./ResendActivation.vue?vue&type=template&id=c0eac1fc&scoped=true"
import script from "./ResendActivation.vue?vue&type=script&lang=js"
export * from "./ResendActivation.vue?vue&type=script&lang=js"
import style0 from "./ResendActivation.vue?vue&type=style&index=0&id=c0eac1fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0eac1fc",
  null
  
)

export default component.exports